import { render, staticRenderFns } from "./indexBase.vue?vue&type=template&id=5a1021be&scoped=true"
import script from "./indexBase.vue?vue&type=script&lang=js"
export * from "./indexBase.vue?vue&type=script&lang=js"
import style0 from "./indexBase.vue?vue&type=style&index=0&id=5a1021be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1021be",
  null
  
)

export default component.exports